import { OptionalString } from '@/app/core';
import { InputLabel } from '@ssar-app/domain';
import * as yup from 'yup';

type StringValidationSchema = yup.StringSchema<string | undefined>;

export const NumberSchema: StringValidationSchema = yup.string().test({
  name: 'IsANumber',
  test(value: OptionalString) {
    if (!value) {
      return true;
    } else if (/[^0-9]+/.test(value)) {
      return this.createError({
        message: '${label} should contain numbers only.',
      });
    }
    return true;
  },
});
// .matches(/^[0-9]+$/g, '${label} should contain numbers only.');

export const NumberAndRequiredSchema: StringValidationSchema =
  NumberSchema.required();

export const NotANumberSchema: StringValidationSchema = yup.string().test({
  name: 'IsNotANumber',
  test(value: OptionalString) {
    if (!value) {
      return true;
    } else if (/^[0-9]+$/.test(value)) {
      return this.createError({
        message: '${label} cannot be a number.',
      });
    }
    return true;
  },
});

export const NotANumberAndRequiredSchema: StringValidationSchema =
  NotANumberSchema.required();

export const DoesNotHaveANumberSchema: StringValidationSchema = yup
  .string()
  .test({
    name: 'DoesNotHaveANumber',
    test(value: OptionalString) {
      if (!value) {
        return true;
      } else if (/[0-9]/.test(value)) {
        return this.createError({
          message: '${label} cannot contain a number.',
        });
      }
      return true;
    },
  });

export const DoesNotHaveANumberAndRequiredSchema: StringValidationSchema =
  DoesNotHaveANumberSchema.required();

export const ContentLengthSchema = (fieldName = 'Field'): yup.StringSchema => {
  return yup
    .string()
    .label(fieldName)
    .test({
      name: 'ContentLength',
      test(value?: string) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const anyContext = this.options.context as any;
        const inputLabelsMap = anyContext?.getInputLabelsMap();
        if (!inputLabelsMap) {
          return this.createError({
            message:
              'Input Labels Map is not provided in the validation context.',
          });
        } else {
          const fieldLength =
            (inputLabelsMap[fieldName.toLowerCase()] as InputLabel)
              ?.fieldLength || 50;
          if (value && value.length > fieldLength) {
            return this.createError({
              message: `Length of the content of this field cannot exceed ${fieldLength}`,
            });
          }
          return true;
        }
      },
    });
};

export const SSNSchema: StringValidationSchema = yup
  .string()
  .transform((value: string | undefined) => value?.trim())
  .matches(/^\s*(\d{1,3})\s*[-]?\s*\d{2}\s*[-]?\s*\d{4}\s*$/i, {
    excludeEmptyString: true,
    message: 'Invalid format for a SSN.',
  });
